if (!customElements.get("product-form")) {
    customElements.define("product-form", class t extends HTMLElement {
        constructor() {
            super();
            this.form = this.querySelector("form");
            this.form.querySelector("[name=id]").disabled = false;
            this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
            this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
            this.submitButton = this.querySelector('[type="submit"]');
            if (document.querySelector("cart-drawer")) this.submitButton.setAttribute("aria-haspopup", "dialog");
            this.stickyBtnAnchorSpan = this.form.querySelector(".sticky-btn-anchor");
            if (this.stickyBtnAnchorSpan) {
                this.toggleStickyAnchorSpan();
                this.stickyBtnAnchorSpan.addEventListener("click", (t => {
                    t.preventDefault();
                    const e = document.querySelector(".variant-radios");
                    const s = 60;
                    const r = window.scrollY || window.pageYOffset;
                    const i = e.getBoundingClientRect().top + r - s;
                    window.scrollTo({top: i, behavior: "smooth"})
                }))
            }
        }

        toggleStickyAnchorSpan(t) {
            if (this.submitButton.disabled) {
                this.stickyBtnAnchorSpan.classList.add("is-visible")
            } else {
                this.stickyBtnAnchorSpan.classList.remove("is-visible")
            }
        }

        onSubmitHandler(t) {
            t.preventDefault();
            if (this.submitButton.getAttribute("aria-disabled") === "true") return;
            this.handleErrorMessage();
            this.submitButton.setAttribute("aria-disabled", true);
            this.submitButton.classList.add("loading");
            this.querySelector(".loading-overlay__spinner").classList.remove("hidden");
            const e = fetchConfig("javascript");
            e.headers["X-Requested-With"] = "XMLHttpRequest";
            delete e.headers["Content-Type"];
            const s = new FormData(this.form);
            if (this.cart) {
                s.append("sections", this.cart.getSectionsToRender().map((t => t.id)));
                s.append("sections_url", window.location.pathname);
                this.cart.setActiveElement(document.activeElement)
            }
            e.body = s;
            fetch(`${routes.cart_add_url}`, e).then((t => t.json())).then((t => {
                if (t.status) {
                    this.handleErrorMessage(t.description);
                    const e = this.submitButton.querySelector(".sold-out-message");
                    if (!e) return;
                    this.submitButton.setAttribute("aria-disabled", true);
                    this.submitButton.querySelector("span").classList.add("hidden");
                    e.classList.remove("hidden");
                    this.error = true;
                    return
                } else if (!this.cart) {
                    window.location = window.routes.cart_url;
                    return
                }
                if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: "product-form"});
                this.error = false;
                this.showAddToCartSuccess();
                this.showButtonConfirmation();
                const e = this.closest("quick-add-modal");
                if (e) {
                    document.body.addEventListener("modalClosed", (() => {
                        setTimeout((() => {
                            this.cart.renderContents(t)
                        }))
                    }), {once: true});
                    e.hide(true)
                } else {
                    this.cart.renderContents(t)
                }
            })).catch((t => {
                console.error(t)
            })).finally((() => {
                this.submitButton.classList.remove("loading");
                if (this.cart && this.cart.classList.contains("is-empty")) this.cart.classList.remove("is-empty");
                if (!this.error) this.submitButton.removeAttribute("aria-disabled");
                this.querySelector(".loading-overlay__spinner").classList.add("hidden")
            }))
        }

        handleErrorMessage(t = false) {
            this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
            if (!this.errorMessageWrapper) return;
            this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");
            this.errorMessageWrapper.toggleAttribute("hidden", !t);
            if (t) {
                this.errorMessage.textContent = t
            }
        }

        showAddToCartSuccess() {
            const successMessage = document.getElementById("add-to-cart-success");
            if (!successMessage) return;
            successMessage.classList.remove("is-hiding");
            successMessage.classList.add("is-visible");
            setTimeout((() => {
                successMessage.classList.remove("is-visible");
                successMessage.classList.add("is-hiding")
            }), 4e3)
        }

        showButtonConfirmation() {
            if (!this.submitButton) return;
            console.log("🎯 showButtonConfirmation triggered", this.submitButton);
            this.submitButton.classList.add("is-showing-confirmation");
            setTimeout((() => {
                this.submitButton.classList.remove("is-showing-confirmation")
            }), 4e3)
        }
    })
}